import TarifaLista from './tarifa-lista.vue';
import TarifaFicha from './tarifa-ficha.vue';
import TarifaCalculadorV3 from './tarifa-calculador-v3.vue';
import TarifaConfigGlobal from './tarifa-config-global.vue';
import TarifaEditorHerramientas from './tarifa-editor-herramientas.vue';
import RoutesUtils from './../../js/RoutesUtils.js';

var routes = [
    {
        path: '/tarifas/',
        beforeEnter: RoutesUtils.checkAuthPage,
        async: RoutesUtils.checkPermission('tarifas', ['ADMIN', 'INSPECTOR'], TarifaLista),
        keepAlive: true
    },
    {
        path: '/tarifas/new/',
        beforeEnter: RoutesUtils.checkAuthPage,
        async: RoutesUtils.checkPermission('tarifas/new', ['ADMIN', 'INSPECTOR'], TarifaFicha)
    },
    {
        path: '/tarifas/edit/:id/',
        beforeEnter: RoutesUtils.checkAuthPage,
        async: RoutesUtils.checkPermission('tarifas/edit', ['ADMIN', 'INSPECTOR'], TarifaFicha)
    },
    {
        path: '/tarifas/view/:id/',
        beforeEnter: RoutesUtils.checkAuthPage,
        async: RoutesUtils.checkPermission('tarifas/view', ['ADMIN', 'INSPECTOR'], TarifaFicha, { editable: false })
    },
    {
        path: '/tarifas/calculador-v3/',
        beforeEnter: RoutesUtils.checkAuthPage,
        async: RoutesUtils.checkPermission('tarifas/calculador-v3', ['ADMIN', 'INSPECTOR'], TarifaCalculadorV3)
    },
    {
        path: '/tarifas/calculador-v3/:herramientaCodigo/',
        beforeEnter: RoutesUtils.checkAuthPage,
        async: RoutesUtils.checkPermission('tarifas/calculador-v3', ['ADMIN', 'INSPECTOR'], TarifaCalculadorV3)
    },
    {
        path: '/tarifas/config-global/',
        beforeEnter: RoutesUtils.checkAuthPage,
        async: RoutesUtils.checkPermission('tarifas/config-global', ['ADMIN'], TarifaConfigGlobal)
    },
    {
        path: '/tarifas/editor-herramientas/',
        beforeEnter: RoutesUtils.checkAuthPage,
        async: RoutesUtils.checkPermission('tarifas/editor-herramientas', ['ADMIN'], TarifaEditorHerramientas)
    }
];
export default routes;
